module.exports = __webpack_public_path__ + "static/media/Icons for EM-02.251ba119.svg";